/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundTimeForwardIcon16Light = forwardRef('ArrowRoundTimeForwardIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M13 1.253a.5.5 0 0 1 1 0V5.5a.5.5 0 0 1-.5.5h-4a.5.5 0 1 1 0-1h2.9a5.5 5.5 0 1 0 .286 4.333.5.5 0 1 1 .943.333A6.5 6.5 0 1 1 13 4.036V1.253Z" })));
});
